import React from 'react';
import moment from "moment";

const Time = (props) => {
    return moment(props.time).format('M/D/YYYY hh:mm A');
};

export default Time;
